<template>
  <div class="login">
    <div class="left">
      <div style="    position: relative;">
        <img
          src="../assets/xin/xin (4).png"
          style="height: 55.55vh; width: 100%"
          alt=""
          srcset=""
        />
        <div
          style="width: 25%;
    height: 69px;
    padding: 10px;
    display: flex;
    position: absolute;
    top: 0px;
    right: 0px;
    justify-content: center;
    align-items: center;
    background: rgb(255, 255, 255);"
        >
          <img
            style="width: 80%;
    height: 30px;"
            src="@/assets/xin/logo.png"
            alt=""
          />
        </div>
      </div>
      <div
        style="
          flex: 1;
          display: flex;
          padding: 16px 80px;
          justify-content: center;
          background: #323f5a;
         
        "
      >
        <div
          style="
            flex: 1;
            display: flex;
            width: 80%;
            color: #fff;
            justify-content: center;
            flex-direction: column;
          "
        >
          <div
            style="
              font-size: 24px;
              font-weight: 500;
              color: #ffffff;
              margin-bottom: 20px;
            "
          >
            联系我们
          </div>
          <div
            style="
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <div style="position: relative;">
              <div style="font-size: 17px; margin-bottom: 5px">
                业务联系电话
              </div>
              <div
                style="
                  display: flex;
                  justify_content: center;
                  align-items: center;
                  font-size: 17px;
                "
              >
                <img
                  style="width: 28px; height: 28px; margin-right: 7px"
                  src="@/assets/xin/xin (7).png"
                /><span style="color: #9a9a9e">13140161000</span>
              </div>
              <div
                @mouseover="ywshang"
                @mouseout="ywchu"
                style="
                  display: flex;
                  justify_content: center;
                  align-items: center;
                  font-size: 17px;
                "
              >
                <img
                  style="width: 28px; height: 28px; margin-right: 7px"
                  src="@/assets/xin/xin (6).png"
                /><span>13140161000</span>
              </div>
              <div
                v-if="yewu"
                style="width: 160px;
height: 160px;
background: #FFFFFF;
display: flex;
   position: absolute;
    left: 165px;
    top: 0px;
    z-index: 9999;
    justify-content: center;
    align-items: center;
box-shadow: 0px 8px 20px 1px rgba(0,0,0,0.08);
border-radius: 20px 20px 20px 20px;"
              >
                <img
                  style="width:140px;height:140px"
                  src="@/assets/xin/xin (2).png"
                  alt=""
                  srcset=""
                />
              </div>
            </div>
            <div style="position: relative;">
              <div style="font-size: 17px; margin-bottom: 5px">
                技术联系电话
              </div>
              <div
                style="
                  display: flex;
                  justify_content: center;
                  align-items: center;
                  font-size: 17px;
                "
              >
                <img
                  style="width: 28px; height: 28px; margin-right: 7px"
                  src="@/assets/xin/xin (7).png"
                /><span style="color: #9a9a9e">13838271800</span>
              </div>
              <div
                @mouseover="jsshang"
                @mouseout="jschu"
                style="
                  display: flex;
                  justify_content: center;
                  align-items: center;
                  font-size: 17px;
                "
              >
                <img
                  style="width: 28px; height: 28px; margin-right: 7px"
                  src="@/assets/xin/xin (6).png"
                /><span>13838271800</span>
              </div>
              <div
                v-if="jishu"
                style="width: 160px;
height: 160px;
background: #FFFFFF;
display: flex;
    justify-content: center;
    position: absolute;
    left: 165px;
    top: 0px;
    z-index: 9999;
    align-items: center;
box-shadow: 0px 8px 20px 1px rgba(0,0,0,0.08);
border-radius: 20px 20px 20px 20px;"
              >
                <img
                  style="width:140px;height:140px"
                  src="@/assets/xin/xin (3).png"
                  alt=""
                  srcset=""
                />
              </div>
            </div>
            <div>
              <div style="font-size: 17px; margin-bottom: 5px">服务邮箱</div>
              <div
                style="
                  display: flex;
                  justify_content: center;
                  align-items: center;
                  font-size: 17px;
                "
              >
                <img
                  style="width: 28px; height: 28px; margin-right: 7px"
                  src="@/assets/xin/xin (12).png"
                /><span style="color: #9a9a9e">yzdsjyjy@126.com</span>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            flex: 1;
            display: flex;
            width: 80%;
            color: #fff;
            justify-content: center;
            flex-direction: column;
          "
        >
          <div
            style="
              font-size: 24px;
              font-weight: 500;
              color: #ffffff;
              margin-bottom: 20px;
            "
          >
            投诉举报
          </div>
          <div
            style="
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <div>
              <div style="font-size: 17px; margin-bottom: 5px">
                违法和不良信息举报
              </div>
              <div
                style="
                  display: flex;
                  justify_content: center;
                  align-items: center;
                  font-size: 17px;
                "
              >
                <img
                  style="width: 28px; height: 28px; margin-right: 7px"
                  src="@/assets/xin/xin (7).png"
                /><span style="color: #9a9a9e">0377-62268666</span>
              </div>
            </div>
            <div>
              <div style="font-size: 17px; margin-bottom: 5px">
                投诉侵权及摘抄模仿电话
              </div>
              <div
                style="
                  display: flex;
                  justify_content: center;
                  align-items: center;
                  font-size: 17px;
                "
              >
                <img
                  style="width: 28px; height: 28px; margin-right: 7px"
                  src="@/assets/xin/xin (7).png"
                /><span style="color: #9a9a9e">0371-55555404</span>
              </div>
            </div>
            <div>
              <div style="font-size: 17px; margin-bottom: 5px">举报邮箱</div>
              <div
                style="
                  display: flex;
                  justify_content: center;
                  align-items: center;
                  font-size: 17px;
                "
              >
                <img
                  style="width: 28px; height: 28px; margin-right: 7px"
                  src="@/assets/xin/xin (12).png"
                /><span style="color: #9a9a9e">yzdsjyjy@126.com</span>
              </div>
            </div>
          </div>
        </div>
        <div
          style="
            flex: 1;
            display: flex;
            width: 80%;
            color: #fff;
            justify-content: center;
            flex-direction: column;
          "
        >
          <div
            style="
              font-size: 24px;
              font-weight: 500;
              color: #ffffff;
              margin-bottom: 20px;
            "
          >
            官方客服
          </div>
          <div
            style="
              flex: 1;
              display: flex;
              flex-direction: column;
              justify-content: space-between;
            "
          >
            <div
              style="width: 180px;
height: 180px;
background: #FFFFFF;
display: flex;
    justify-content: center;
    align-items: center;
box-shadow: 0px 8px 20px 1px rgba(0,0,0,0.08);
border-radius: 20px 20px 20px 20px;"
            >
              <img
                style="width:160px;height:160px"
                src="@/assets/xin/xin (1).png"
                alt=""
                srcset=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="right">
      <div class="loginCard">
        <div class="loginTitle">
          <div class="zititet">账号注册</div>
          <!-- <img src="../assets/login/welcome.png" alt /> -->
        </div>
        <div class="tab">
          <!-- <div @click="tab(1)">
            豫资签登录
            <span v-if="active==1" class="block"></span>
          </div> -->
          <!-- <div @click="tab(2)">
            账号注册
            <span v-if="active==2" class="block"></span>
          </div> -->
        </div>
        <div class="form" v-if="active == 2">
          <el-form
            class="cionlogin"
            :model="loginFrom"
            :rules="rules"
            ref="loginFrom"
          >
            <el-form-item prop="username">
              <el-input
                prefix-icon="el-icon-user-solid"
                placeholder="请输入账号"
                v-model="loginFrom.username"
              ></el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input
                prefix-icon="el-icon-lock"
                placeholder="请输入密码"
                type="password"
                v-model="loginFrom.password"
              ></el-input>
            </el-form-item>
            <el-form-item prop="passwords">
              <el-input
                prefix-icon="el-icon-lock"
                placeholder="请再次输入密码"
                type="password"
                v-model="loginFrom.passwords"
              ></el-input>
            </el-form-item>
            <el-form-item prop="mobile">
              <el-input
                prefix-icon="el-icon-phone"
                placeholder="请输入手机号"
                type=""
                v-model="loginFrom.mobile"
              ></el-input>
            </el-form-item>
            <el-form-item prop="yzm">
              <div class="code">
                <el-input
                  prefix-icon="el-icon-coordinate"
                  placeholder="请输入验证码"
                  v-model="loginFrom.yzm"
                ></el-input>
                <div
                  style="display: flex;
    justify-content: center;
    margin-left: 10px;
}"
                  class="codeImg"
                  @click="getcodeimg"
                >
                  <el-button
                    :disabled="times !== 90"
                    style="     width: 90px;   padding: 9px;
    height: 40px;"
                    @click="send"
                    type="primary"
                    plain
                    >{{ yanzheng }}</el-button
                  >
                </div>
              </div>
            </el-form-item>
            <el-form-item prop="tuijian_code">
              <el-input
                prefix-icon="el-icon-s-custom"
                placeholder="请输入推荐人"
                type=""
                v-model="loginFrom.tuijian_code"
              ></el-input>
            </el-form-item>
          </el-form>
          <div
            style="    display: flex;
    justify-content: flex-end;"
          >
            <el-link type="primary" @click="$router.push('/login')"
              >去登陆</el-link
            >
            <!-- <el-checkbox label="记住密码" name="type"></el-checkbox> -->
            <!-- <div @click="$router.push('/register')">注册账号</div> -->
            <!-- <div @click="$p.url('/forget')">忘记密码</div> -->
          </div>
          <div class="loginBtn">
            <el-button type="primary" @click="login">注册</el-button>
          </div>
        </div>
        <div class="form" v-if="active == 1">
          <div class="caImg">
            <img src="../assets/login/CAPassword.png" alt />
          </div>
          <div class="loginBtn">
            <el-button type="primary" @click="logins">豫资签登录</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { register } from "@/api/system/login";
import axios from "axios";
export default {
  data() {
    return {
      active: 2,
      loginFrom: {
        // username: "wang",
        // password: "111111",
        username: "",
        password: "",
        mobile: "",
        yzn: "",
        tuijian_code: ""
        // id: ""
      },
      times: 90,
      jishu: false,
      yewu: false,
      yanzheng: "获取验证码",
      codeUrl: "",
      rules: {
        password: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 8,
            max: 16,
            message: "长度在 8 到 16 个字符",
            trigger: "blur"
          }
        ],
        passwords: [
          { required: true, message: "请输入密码", trigger: "blur" },
          {
            min: 8,
            max: 16,
            message: "长度在 8 到 16 个字符",
            trigger: "blur"
          }
        ],
        username: [{ required: true, message: "请输入账号", trigger: "blur" }],
        mobile: [
          {
            type: "date",
            required: true,
            message: "请输入手机号",
            trigger: "blur"
          }
        ],
        yzm: [
          {
            type: "date",
            required: true,
            message: "请输入验证码",
            trigger: "blur"
          }
        ],
        type: [
          {
            type: "array",
            required: true,
            message: "请至少选择一个活动性质",
            trigger: "change"
          }
        ],
        resource: [
          { required: true, message: "请选择活动资源", trigger: "change" }
        ],
        desc: [{ required: true, message: "请填写活动形式", trigger: "blur" }]
      },
      captchaOnOff: false
    };
  },
  mounted() {
    this.getcodeimg();
  },
  methods: {
    getcodeimg() {
      // getcode().then(res=>{
      //     this.codeUrl = window.URL.createObjectURL(res)
      // })
    },
    logins() {
      this.$alert("检测不到豫资签", "警告", {
        confirmButtonText: "确定",
        callback: action => {
          // this.$message({
          //   type: 'info',
          //   message: `action: ${ action }`
          // });
        }
      });
    },
    ywshang() {
      this.yewu = true;
    },
    ywchu() {
      this.yewu = false;
    },
    jsshang() {
      this.jishu = true;
    },
    jschu() {
      this.jishu = false;
    },
    login() {
      this.$refs["loginFrom"].validate((valid) => {
          if (valid) {
            register(this.loginFrom).then(res => {
        // sessionStorage.setItem("token", res.data.data.token);
        //  sessionStorage.setItem("cardname", res.data.data.cardname);
        // sessionStorage.setItem("user_id", res.data.data.id);
        // console.log( res.data.data.id,'user');
        if (res.data.code == 1) {
          // this.cionbutton = true;
          this.$message({
            message: res.data.msg,
            type: "success"
          });
          this.daojishi();
          // this.$router.push("/BidSecurity/ElectronicProtocol");
        } else {
          this.$message.error(res.data.msg);
        }
      });
          } else {
            console.log('error submit!!');
            return false;
          }
        });
   
    },
    tab(i) {
      this.active = i;
    },
    send() {
      if (this.mobile == "") {
        return this.$message({
          showClose: true,
          message: "请输入手机号",
          type: "warning"
        });
      }
      // this.daojishi();
      // return;
      axios({
        url: "https://api.hnzyxsbh.com/apply/sms/send",
        method: "post", // params: '必须是一个无格式对象 query参数',
        data: {
          mobile: this.loginFrom.mobile,
          event: "register"
        },
        timeout: 10000,
        headers: {
          token: sessionStorage.getItem("token")
        }
      })
        .then(res => {
          console.log(res.data.msg);
          if (res.data.code == 1) {
            this.cionbutton = true;
            this.$message({
              message: res.data.msg,
              type: "success"
            });
            this.daojishi();
            // this.$router.push("/BidSecurity/ElectronicProtocol");
          } else {
            this.$message.error(res.data.msg);
          }
          // this.$router.push("/BidSecurity/Bidpayment");
        })
        .catch(err => {
          console.log("失败", err);
          // this.$notify.error({
          //   message: err.response.data.msg,
          // });
        });
    },
    daojishi() {
      // return
      var that = this;
      if (this.times == 0) {
        this.times = 90;
        clearTimeout(this.yanTimer);
        this.cionbutton = false;
        this.yanzheng = "获取验证码";
      } else {
        this.times--;
        this.yanzheng = this.times + "s";
        this.yanTimer = setTimeout(() => {
          that.daojishi();
        }, 1000);
      }
    },
    blobToBase64(blob) {
      return new Promise((resolve, reject) => {
        const fileReader = new FileReader();
        fileReader.onload = e => {
          resolve(e.target.result);
        };
        // readAsDataURL
        fileReader.readAsDataURL(blob);
        fileReader.onerror = () => {
          reject(new Error("blobToBase64 error"));
        };
      });
    }
  }
};
</script>
<style>
.cionlogin .el-input--prefix .el-input__inner {
  padding-left: 40px !important;
}
.el-icon-user-solid:before {
  content: "\E7A5";
  font-size: 22px;
}
.el-icon-lock:before {
  content: "\E6E5";
  font-size: 22px;
}
.el-icon-coordinate:before {
  content: "\E76B";
  font-size: 22px;
}
</style>
<style scoped lang="scss">
.zititet {
  font-size: 25px;
  font-weight: 900;
  font-family: "Helvetica Neue", Helvetica, "PingFang SC", "Hiragino Sans GB",
    "Microsoft YaHei", "微软雅黑", Arial, sans-serif;
}
.login {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  background: #5a7aec;
  .left {
    width: 60%;
    display: flex;
    flex-direction: column;
    // align-items: center;
    // justify-content: center;
    height: 100%;
    .leftBanner {
      width: 690px;
      height: 690px;
    }
  }
  .right {
    flex: 1;
    height: 100%;
    display: flex;
    // align-items: center;
    justify-content: center;
    background: #fff;

    .loginCard {
      // padding: 30px;
      width: 450px;
      margin-top: 20%;
      height: 600px;
      box-shadow: 0px 0px 5px 1px rgba(0, 0, 0, 0.1);
      border-radius: 0px 0px 0px 0px;
      opacity: 1;
      border: 1px solid #f5f5f5;
      .tab {
        display: flex;
        align-items: center;
        justify-content: space-evenly;
        div {
          font-size: 18px;
          font-family: PingFang SC-Semibold, PingFang SC;
          font-weight: 600;
          color: #333333;
          width: 30%;
          height: 75px;
          line-height: 75px;
          text-align: center;
          position: relative;
          cursor: pointer;
          span {
            display: inline-block;
            width: 100%;
            height: 3px;
            background: #1890ff;
            position: absolute;
            bottom: 0;
            left: 0;
          }
        }
      }
      .title {
        margin-top: 10px;
        margin-left: 150px;
      }
      .form {
        // width: 400px;
        padding: 30px;
        .caImg {
          width: 200px;
          height: 113px;
          margin: 0 auto;
          margin-top: 5px;
          margin-bottom: 30px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
      }
      .loginTitle {
        display: flex;
        align-items: center;
        justify-content: center;
        margin-top: 30px;
      }
      .isPassword {
        font-size: 12px;
        display: flex;
        padding-left: 10px;
        margin-bottom: 20px;
        align-items: center;
        justify-content: space-between;
        & > div {
          cursor: pointer;
        }
        & > div:nth-child(1) {
          color: #1890ff;
        }
      }
      .el-form-item__error {
        padding-left: 10px;
      }
      .code {
        display: flex;
        align-items: center;
        .codeImg {
          height: 40px;
        }
      }
      .loginBtn {
        padding-top: 23px;
        width: 100%;
        display: flex;
        justify-content: center;
        // margin-left: 35px;
        button {
          width: 300px;
          background: #1890ff;
          color: #fff;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/view/register.vue